import { render, staticRenderFns } from "./addQuestionAnswerList.vue?vue&type=template&id=552629c6&scoped=true"
import script from "./addQuestionAnswerList.vue?vue&type=script&lang=js"
export * from "./addQuestionAnswerList.vue?vue&type=script&lang=js"
import style0 from "./addQuestionAnswerList.vue?vue&type=style&index=0&id=552629c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552629c6",
  null
  
)

export default component.exports